import { createClient } from '@supabase/supabase-js';
import { assertSupabaseEnv, env } from '../config/env';

let client: ReturnType<typeof createClient> | null = null;

export function getSupabaseClient() {
  assertSupabaseEnv();
  if (!client) {
    client = createClient(env.VITE_SUPABASE_URL!, env.VITE_SUPABASE_ANON_KEY!, {
      auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true },
    });
  }
  return client;
}
